import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

const AccountIcon = ({ ...rest }: IconWrapperProps) => (
  <IconWrapper title="Account" viewBox="0 0 24 24" {...rest}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 6c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4ZM6 6c0 3.309 2.691 6 6 6H7.977a4.97 4.97 0 0 0-4.79 3.563l-2.145 7.15a1.001 1.001 0 0 0 1.916.574l2.145-7.149A2.98 2.98 0 0 1 7.977 14h8.046a2.98 2.98 0 0 1 2.874 2.138l2.145 7.149a1 1 0 1 0 1.916-.574l-2.145-7.15A4.97 4.97 0 0 0 16.023 12H12c3.31 0 6-2.691 6-6s-2.69-6-6-6C8.691 0 6 2.691 6 6Z"
      clipRule="evenodd"
    />
  </IconWrapper>
);

export default AccountIcon;
